import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { BrandCaptionLowerThirdActions } from "@youm-front/brand/data-access";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { RoomBrandCaptionLowerThirdActions } from "../actions";
import {
  RoomBrandCaptionLowerThirdCreateRequestDTO,
  RoomBrandCaptionLowerThirdDeleteRequestDTO,
  RoomBrandCaptionLowerThirdUnUseRequestDTO,
  RoomBrandCaptionLowerThirdUpdateRequestDTO,
  RoomBrandCaptionLowerThirdUseRequestDTO
} from "../dto";
import { RoomBrandCaptionLowerThirdService } from "../services";

@Injectable()
export class RoomBrandCaptionLowerThirdEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomBrandCaptionLowerThirdService: RoomBrandCaptionLowerThirdService
  ) {}

  roomBrandCaptionLowerThirdCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdCreate
      ),
      switchMap((_) =>
        this.roomBrandCaptionLowerThirdService
          .roomBrandCaptionLowerThirdCreate(
            new RoomBrandCaptionLowerThirdCreateRequestDTO({
              roomId: _.roomBrandCaptionLowerThirdCreateVO.value.roomId,
              brandId: _.roomBrandCaptionLowerThirdCreateVO.value.brandId,
              caption: _.roomBrandCaptionLowerThirdCreateVO.value.caption
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdCreateSuccess(
                {
                  brandCaptionLowerThird: _.data.caption
                }
              ),
              BrandCaptionLowerThirdActions.brandCaptionLowerThirdCreateSuccess(
                {
                  brandCaptionLowerThird: _.data.caption
                }
              )
            ]),
            catchError((_: Error) => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdCreateFailure(
                {
                  error: _.message
                }
              )
            ])
          )
      )
    )
  );

  roomBrandCaptionLowerThirdDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdDelete
      ),
      switchMap((_) =>
        this.roomBrandCaptionLowerThirdService
          .roomBrandCaptionLowerThirdDelete(
            new RoomBrandCaptionLowerThirdDeleteRequestDTO({
              roomId: _.roomBrandCaptionLowerThirdDeleteVO.value.roomId,
              caption:
                _.roomBrandCaptionLowerThirdDeleteVO.value
                  .brandCaptionLowerThird
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdDeleteSuccess(
                {
                  brandCaptionLowerThird: _.data.caption
                }
              ),
              BrandCaptionLowerThirdActions.brandCaptionLowerThirdDeleteSuccess(
                {
                  brandCaptionLowerThird: _.data.caption
                }
              )
            ]),
            catchError((_: Error) => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdDeleteFailure(
                {
                  error: _.message
                }
              )
            ])
          )
      )
    )
  );

  roomBrandCaptionLowerThirdUnUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUnUse),
      switchMap((_) =>
        this.roomBrandCaptionLowerThirdService
          .roomBrandCaptionLowerThirdUnUse(
            new RoomBrandCaptionLowerThirdUnUseRequestDTO({
              roomId: _.roomBrandCaptionLowerThirdUnUseVO.value.roomId,
              caption:
                _.roomBrandCaptionLowerThirdUnUseVO.value.brandCaptionLowerThird
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUnUseSuccess(
                {
                  brandCaptionLowerThird:
                    _.roomBrandCaptionLowerThirdUnUseVO.value
                      .brandCaptionLowerThird
                }
              ),
              BrandCaptionLowerThirdActions.brandCaptionLowerThirdUnUseSuccess({
                brandCaptionLowerThird:
                  _.roomBrandCaptionLowerThirdUnUseVO.value
                    .brandCaptionLowerThird
              })
            ]),
            catchError((_: Error) => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUnUseFailure(
                {
                  error: _.message
                }
              )
            ])
          )
      )
    )
  );

  roomBrandCaptionLowerThirdUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUpdate
      ),
      switchMap((_) =>
        this.roomBrandCaptionLowerThirdService
          .roomBrandCaptionLowerThirdUpdate(
            new RoomBrandCaptionLowerThirdUpdateRequestDTO({
              roomId: _.roomBrandCaptionLowerThirdUpdateVO.value.roomId,
              captionId: _.roomBrandCaptionLowerThirdUpdateVO.value.captionId,
              brandId: _.roomBrandCaptionLowerThirdUpdateVO.value.brandId,
              update: _.roomBrandCaptionLowerThirdUpdateVO.value.update
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUpdateSuccess(
                {
                  brandCaptionLowerThird: _.data.caption
                }
              ),
              BrandCaptionLowerThirdActions.brandCaptionLowerThirdUpdateSuccess(
                {
                  brandCaptionLowerThird: _.data.caption
                }
              )
            ]),
            catchError((_: Error) => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUpdateFailure(
                {
                  error: _.message
                }
              )
            ])
          )
      )
    )
  );

  roomBrandCaptionLowerThirdUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUse),
      switchMap((_) =>
        this.roomBrandCaptionLowerThirdService
          .roomBrandCaptionLowerThirdUse(
            new RoomBrandCaptionLowerThirdUseRequestDTO({
              roomId: _.roomBrandCaptionLowerThirdUseVO.value.roomId,
              caption:
                _.roomBrandCaptionLowerThirdUseVO.value.brandCaptionLowerThird
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUseSuccess(
                {
                  brandCaptionLowerThird:
                    _.roomBrandCaptionLowerThirdUseVO.value
                      .brandCaptionLowerThird
                }
              ),
              BrandCaptionLowerThirdActions.brandCaptionLowerThirdUseSuccess({
                brandCaptionLowerThird:
                  _.roomBrandCaptionLowerThirdUseVO.value.brandCaptionLowerThird
              })
            ]),
            catchError((_: Error) => [
              RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUseFailure(
                {
                  error: _.message
                }
              )
            ])
          )
      )
    )
  );
}
